export default __webpack_public_path__ + "static/media/Roboto-Black.02c9845e.woff";